<div class="sol-card-custom">
    <div class="row">
        <div class="col p-0 pl-3 pb-2 game-icon" *ngIf="gameStatus !== 'Ended'">
            <svg *ngIf="game.iconClass; else noIcon" class="container-svg" viewBox="0 0 120 120">
                <image [attr.href]="getWidgetGroupSvgPath(game.iconClass)" />
            </svg>
            <ng-template #noIcon>
                <span class="text-double-dash">--</span>
            </ng-template>
        </div>
        <div class="col p-0 pl-3 pb-2 relative justify-content-center d-flex game-icon" *ngIf="gameStatus === 'Ended'">
            <div class="game-over-label">{{getLocalizationString("Game_Over", "Game Over")}}</div>
            <svg class="container-svg" viewBox="0 0 120 120">
                <!--apply filter to alpha effect for ended games-->
                <filter id="endedFilter">
                    <feColorMatrix in="SourceGraphic" type="saturate" values="0"></feColorMatrix>
                    <feGaussianBlur stdDeviation="1"></feGaussianBlur>
                </filter>
                <image [attr.href]="getWidgetGroupSvgPath(game.iconClass)" filter="url(#endedFilter)" />
            </svg>
        </div>
        <div class="col pr-3 pl-3 pb-2">
            <!-- #tooltipContainer to know the size of the text and show tooltip -->
            <div class="title-container">{{ game.underlyingRule.RuleName }}</div>
            <div #tooltipText class="card-name-overflow game-title" [tooltip]="displayTooltip(game.underlyingRule.RuleName)" placement="top" container="body" containerClass="cxone-game-card-label-tooltip"
                (mouseenter)="isTextTruncated ? tooltip.show() : tooltip.hide()" 
                triggers="manual"
                #tooltip="bs-tooltip"
                (mouseleave)="tooltip.hide()"
                (wheel)="tooltip.hide()">
                <span>{{ game.underlyingRule.RuleName }}</span>
            </div>
            <div class="row">
                <div class="col-12 d-flex">
                    <span class="mr-1">
                        <svg class="icon-16">
                            <use href="../../../App_Themes/CXone/icons/gamification/games/coin-reward.svg#coin-reward"></use>
                        </svg>
                    </span>
                    <span #coinsTooltipContainer class="earning-text-container">
                        <span class="earned-label">{{getLocalizationString("Earned_Coins", "Earned coins")}}: </span>
                        <h5>{{getEarnedCoins()}}</h5>
                    </span>
                    <span #coinsTooltipText class="earning-text" tooltip="{{displayCoinTooltip(getLocalizationString('Earned_Coins', 'Earned coins') + ': ' + getEarnedCoins())}}" containerClass="cxone-game-card-label-tooltip" container="body" placement="top">
                        <span class="earned-label">{{getLocalizationString("Earned_Coins", "Earned coins")}}: </span>
                        <span class="text-double-dash" *ngIf="gameStatus === 'Upcoming'">--</span>
                        <h5 *ngIf="gameStatus !== 'Upcoming'">{{getEarnedCoins()}}</h5>
                    </span>
                </div>
            </div>
            <div class="row" *ngIf="game?.underlyingRule.GameType !== 1">
                <div class="col-12 mt-1">
                    <span class="mr-1">
                        <svg class="icon-16">
                            <use href="../../../App_Themes/CXone/icons/gamification/games/badge-reward.svg#badge-reward"></use>
                        </svg>
                    </span>
                    <span class="earned-label">{{game.underlyingRule.GameType === GameType.Milestone ? getLocalizationString("Earned_Badges", "Earned Badges") : getLocalizationString("Earned_Badge", "Earned Badge")}}:</span>
                    <span *ngIf="getEarnedBadges() && getEarnedBadges().length > 0">
                        <span class="ml-1" *ngFor="let badge of getEarnedBadges()" [popover]="popoverTemplateBadge" [adaptivePosition]="false" containerClass="cxone-game-card-badge-popover" 
                        #pop="bs-popover" placement="bottom" triggers="manual" (mouseenter)="pop.show()" (wheel)="pop.hide()" (mouseleave)="pop.hide()">
                            <span *ngIf="getEarnedBadges().length > 0" class="badge-container">
                                <img [src]="badge">
                            </span>
                            <span *ngIf="getEarnedBadges().length === 0" class="text-double-dash">--</span>                             
                            <ng-template #popoverTemplateBadge>
                                <div [innerHTML]="getBadgeImage(badge)"></div>
                            </ng-template>
                        </span>
                    </span>
                    <span *ngIf="!getEarnedBadges() || getEarnedBadges().length === 0" class="mr-1 text-double-dash"> -- </span>
                </div>
            </div>
        </div>
    </div>      
    
    <div [ngSwitch]="game?.underlyingRule.GameType">
        <cxone-game-multiplier-madness *ngSwitchCase="GameType.MultiplierMadness" [game]="game" [gameStatus]="gameStatus" [rankingData]="rankingData"></cxone-game-multiplier-madness>
        <cxone-game-top-team *ngSwitchCase="GameType.TopDog" [game]="game" [gameStatus]="gameStatus" [rankingData]="rankingData"></cxone-game-top-team>
        <cxone-bullseye-game *ngSwitchCase="GameType.Bullseye" [game]="game" [gameStatus]="gameStatus" [ranking]="rankingData"></cxone-bullseye-game>
        <cxone-games-milestone *ngSwitchCase="GameType.Milestone" [game]="game" [gameStatus]="gameStatus" [ranking]="rankingData"></cxone-games-milestone>
        <cxone-games-connect-3 *ngSwitchCase="GameType.Connect3" [game]="game" [ranking]="rankingData" [gameStatus]="gameStatus" [gameType]="GameType.Connect3"></cxone-games-connect-3>
        <cxone-games-connect-3 *ngSwitchCase="GameType.Blackout" [game]="game" [ranking]="rankingData" [gameStatus]="gameStatus" [gameType]="GameType.Blackout"></cxone-games-connect-3>
        <cxone-game-top-team *ngSwitchCase="GameType.TopTeam" [game]="game" [gameStatus]="gameStatus" [rankingData]="rankingData"></cxone-game-top-team>
    </div>

    <div class="flex-container-date mt-2">
        <div class="flex-item-left-date">
            <span class="type-game-text">
                <svg class="icon-16 calendar-icon">
                    <use href="../../../App_Themes/CXone/icons/calendar.svg#calendar"></use>
                </svg> 
                {{formatIntervalType(game.underlyingRule.IntervalType)}}
            </span>
            <span class="status-game-text">
                {{gameDateFormat(game.underlyingRule.StartDate)}} - {{game.underlyingRule.EndDate === null ? getLocalizationString("No_End_Date","No end date") : gameDateFormat(game.underlyingRule.EndDate)}}
            </span>
        </div>
        <div class="flex-item-right-chip d-flex justify-content-end mt-1">
            <div class="ml-1">
                <div class="game-status-container">
                    <div class="status-circle" [ngClass]="'status-color-' + gameStatus?.toLowerCase()"></div>
                    <span class="status-text">{{getLocalizationString(gameStatus === 'Ended' ? gameStatus + '_Status' : gameStatus , gameStatus)}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
